import {getDataWithPromise, Globals, handleAjaxError} from "root/DataFunctions/BaseDataFns";

export const  getMonthName = (value) => {
    let m = ['January','February','March','April','May','June','July','August','September','October','November','December'];
    return m[value];
};

// Team Functions
export const getChildAgeRangesForTeam = (team_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/statistics/' + team_id + '/ageRange?node_level=team';

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
    .catch((jqXHR, textStatus, error) =>
    {
        handleAjaxError(jqXHR, textStatus, error);
    });
}

export const getMessagesForTeam = (team_id, user_type, month, year, message_type, onCompleteFunc) => {

    const url = Globals.APIFolder+'/statistics/'+team_id+'/contributions?node_level=team&user_type='+user_type+'&type=post&month='+month+'&year='+year+'&message_type='+message_type;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getLoginsForTeam = (team_id, user_type, month, year, onCompleteFunc) => {

    const url = Globals.APIFolder + '/statistics/' + team_id + '/logins?node_level=team&user_type='+user_type+'&month='+month+'&year='+year;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getChildDiaryEntriesForTeam = (team_id, month, year, onCompleteFunc) => {

    const url = Globals.APIFolder + '/statistics/' + team_id + '/diary?node_level=team&month='+month+'&year='+year;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

// User Functions
export const getLoginsForUser = (user_id, user_type, month, year, onCompleteFunc) => {

    const url = Globals.APIFolder + '/statistics/' + user_id + '/logins?node_level=user&user_type='+user_type+'&month='+month+'&year='+year;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getMessagesForChild = (user_id, user_type, month, year, message_type, onCompleteFunc) => {

    const url = Globals.APIFolder + '/statistics/' + user_id + '/contributions?node_level=user&user_type='+user_type+'&month='+month+'&year='+year+'&message_type='+message_type;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getMessagesMadeByChild = (user_id, user_type, month, year, message_type, onCompleteFunc) => {

    const url = Globals.APIFolder + '/statistics/' + user_id + '/contributions?node_level=user&user_type='+user_type+'&month='+month+'&year='+year+'&sent&message_type='+message_type;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getChildDiaryEntries = (child_uid, month, year, onCompleteFunc) => {

    const url = Globals.APIFolder + '/statistics/' + child_uid + '/diary?node_level=user&month='+month+'&year='+year;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

// Org Functions
export const getMessagesForOrg = (user_type, org_id, month, year, message_type, onCompleteFunc) => {

    const url = Globals.APIFolder+'/statistics/' + org_id + '/contributions?node_level=organisation&user_type='+user_type+'&month='+month+'&year='+year+'&message_type='+message_type;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getLoginsForOrg = (user_type, month, year, org, onCompleteFunc) => {

    const url = Globals.APIFolder + '/statistics/' + org + '/logins?node_level=organisation&user_type='+user_type+'&month='+month+'&year='+year;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getChildAgeRangesForOrg = ( org_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/statistics/' + org_id + '/ageRange?node_level=organisation';

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getChildDiaryEntriesForOrg = (org_id, month, year, onCompleteFunc) => {

    const url = Globals.APIFolder + '/statistics/' + org_id + '/diary?node_level=organisation&month='+month+'&year='+year;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });
}

export const getOrgUsersByType = ( team_id, onCompleteFunc) => {

    const url = Globals.APIFolder + '/organisation/me/users/type?team_id=' + team_id;

    getDataWithPromise(url, 'GET', {}).then(data =>
    {
        onCompleteFunc ( data );
    })
        .catch((jqXHR, textStatus, error) =>
        {
            handleAjaxError(jqXHR, textStatus, error);
        });

    return ;
};